import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TipoBancaNome } from '../../../model/banca/Banca';
import { BsEye, BsFileEarmarkText, BsPlugFill } from 'react-icons/bs';
import { BiSolidUserPlus } from 'react-icons/bi';
import { FaBalanceScale } from 'react-icons/fa';
import PermissaoWrapper from '../../../components/PermissaoWrapper';
import PermissaoBancaWrapper from '../../../components/PermissaoBancaWrapper';
import { PermissaoEnum } from '../../../model/Usuario/Permissao';
import { BancaNovaResponse } from '../../../model/banca/BancasNovaResponse';
import { getButtonConfigFromBackend } from '../utils/bancaButtonConfigUtils';
import ActionButton from './ActionButton';

interface CandidatosActionsProps {
  banca: BancaNovaResponse;
  processoId?: string;
  onEnviarTermosClick?: (banca: any) => void;
}

const CandidatosActions: React.FC<CandidatosActionsProps> = ({ banca, processoId, onEnviarTermosClick }) => {
  const navigate = useNavigate();

  const navegarParaCandidatos = () => {
    navigate(`${banca.id}/candidatos`, { 
      state: { banca: banca } 
    });
  };

  const navegarParaVincularCandidatos = () => {
    navigate(`${banca.id}/inserir-candidatos`, { 
      state: { banca: banca } 
    });
  };

  const navegarParaRecursos = () => {
    const processId = processoId || banca.processoId;
    navigate(`/processos/${processId}/bancas/${banca.id}/recursos`, { 
      state: { banca: banca } 
    });
  };

  return (
    <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'nowrap', minWidth: 'max-content' }}>
      <PermissaoWrapper permissoesRequiridas={[PermissaoEnum.CONSULTAR_CANDIDATO_BANCA]}>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <ActionButton 
            config={getButtonConfigFromBackend(banca, 'visualizar')} 
            onClick={navegarParaCandidatos}
            customIcon={<BsEye />}
            customTitle="Visualizar Candidatos"
          />
          {banca.hasIntegracao && (
            <BsPlugFill
              style={{ position: 'absolute', top: '-4px', left: '-4px', fontSize: '9px', color: '#0d6efd', backgroundColor: 'white', borderRadius: '50%', zIndex: 1 }}
              title="Integração habilitada"
            />
          )}
        </div>
      </PermissaoWrapper>
      
      <PermissaoBancaWrapper permissoesRequiridas={[PermissaoEnum.VINCULAR_CANDIDATO]} bancaId={banca.id}>
        <ActionButton 
          config={getButtonConfigFromBackend(banca, 'vincular')} 
          onClick={navegarParaVincularCandidatos}
          customIcon={<BiSolidUserPlus />}
          customTitle={banca.tipoBanca?.nome === TipoBancaNome.FACIAL ? 'Automático pela COMVEST' : 'Vincular Candidatos'}
        />
      </PermissaoBancaWrapper>
      
      {banca.tipoBanca?.nome === TipoBancaNome.VIRTUAL && (
        <PermissaoWrapper permissoesRequiridas={[PermissaoEnum.CONSULTAR_RECURSO]}>
          <ActionButton 
            config={getButtonConfigFromBackend(banca, 'recursos')} 
            onClick={navegarParaRecursos}
            customIcon={<FaBalanceScale />}
            customTitle="Recursos"
          />
        </PermissaoWrapper>
      )}
      
      <ActionButton 
        config={getButtonConfigFromBackend(banca, 'enviarTermos')} 
        onClick={() => onEnviarTermosClick?.(banca)}
        customIcon={<BsFileEarmarkText />}
        customTitle="Enviar Termos"
      />
    </div>
  );
};

export default CandidatosActions;